/** @jsxImportSource @emotion/react */
import { Table, useTheme } from '@quickbit/qb-design-system';
import { useNavigate } from 'react-router-dom';
import { RuleViolations } from 'tabs/RulesEngine/api';

export const RuleViolationTable = ({
  violations: violations,
}: {
  violations: RuleViolations[];
}) => {
  const { spacing } = useTheme();
  const navigate = useNavigate();

  const headers = [
    { label: 'User ID', cellKey: 'userId', sort: true },
    {
      label: 'created',
      cellKey: 'createdAt',
      sort: true,
    },
  ];

  const rows = violations.map((violation) => ({
    value: {
      userId: violation.userId,
      createdAt: new Date(violation.createdAt).toLocaleDateString('sv-se'),
    },
  }));

  return (
    <div
      css={{
        marginBottom: spacing.xs,
        'tr:first-child': {
          'td:first-child': { width: '25%' },
          'td:nth-child(2)': { width: '10%' },
        },
      }}
    >
      <Table
        headers={headers}
        rows={rows}
        // eslint-disable-next-line @typescript-eslint/no-base-to-string, @typescript-eslint/restrict-template-expressions
        onRowClick={(row) => void navigate(`/users/app/${row.userId}`)}
      />
    </div>
  );
};
